import { SourceBaseViewType } from "../api-generated";

interface Props {
  type: SourceBaseViewType;
}

const SourceTypeIcon: React.FC<Props> = ({ type }) => {
  let logoFp;
  switch (type) {
    case SourceBaseViewType.googled_lyrics:
      logoFp = "/branding_images/spotify-download-logo-30.png";
      break;
    case SourceBaseViewType.openai_chat:
      logoFp = "/branding_images/openai_please.png";
      break;
    case SourceBaseViewType.youtube_transcript:
      logoFp = "/branding_images/Youtube_logo.png";
      break;
    case SourceBaseViewType.text:
      logoFp = "/branding_images/blue-page.png";
      break;
    default:
      // This will handle any other source types that are not defined in the switch statement
      const _exhaustiveCheck: never = type;
      return _exhaustiveCheck;
  }

  return <img src={logoFp} height={30} width={30} alt="source-logo" />;
};

export default SourceTypeIcon;
